import { render, staticRenderFns } from "./social-post-template-select-widget.vue?vue&type=template&id=e3981822&"
import script from "./social-post-template-select-widget.vue?vue&type=script&lang=js&"
export * from "./social-post-template-select-widget.vue?vue&type=script&lang=js&"
import style0 from "./social-post-template-select-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports